/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import { UPDATE_SET_STEP, UPDATE_SEARCHMDOE_DISPLAY } from '../../constants/actionType'

/**
 * Declare Variable
 */
const updateSetStepAction = createAction(UPDATE_SET_STEP)
const updateSearchModeDisplayAction = createAction(UPDATE_SEARCHMDOE_DISPLAY)
/**
 * Export
 */

export const updateSetStep = (params) => async (dispatch) => {
  dispatch(updateSetStepAction(params))
  return Promise.resolve()
}
export const updateSearchModeDisplay = (bool) => (dispatch) => {
  dispatch(updateSearchModeDisplayAction({
    isSearchMode: bool,
  }))
}



// WEBPACK FOOTER //
// ./src/actions/components/categorydetaillist.js